import { Injectable } from '@angular/core';
import { CanActivate, UrlTree, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, switchMap, take, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { getSchool } from 'Src/ng2/store/selectors/school-selectors';
import { ClearState } from 'Src/ng2/store';
import { isEmpty } from 'lodash-es';
import { UrlNavigationService } from 'Src/ng2/shared/services/url-navigation/url-navigation.service';

@Injectable()
export class ExploreAllViewGuard implements CanActivate {
  constructor (private store: Store<any>) {}

  canActivate (routeSnapshot: ActivatedRouteSnapshot): Observable<UrlTree|boolean> {
    const schoolId = UrlNavigationService.getEntityId(routeSnapshot);

    const school$ = this.store.select(getSchool);
    return school$.pipe(
      take(1),
      tap((schoolOnState) => {
        // If a user is navigating from a single school view back to the explore all view, clear the state to remove the school from the store
        if (!isEmpty(schoolOnState) && !schoolId) {
          this.store.dispatch(new ClearState());
        }
      }),
      switchMap(() => of(true)),
      catchError(() => of(false)),
    );
  };
}
